import { Form, Input } from "antd";

const BooleanRenderer = ({ editing, editable, inputRef, dataIndex, save, toggleEdit, value, children }) => {
  let childNode = children;

  if (editable) {
    let minWidthChildren = children;
    if(Array.isArray(minWidthChildren) && (!minWidthChildren[1] || (minWidthChildren[1].trim && minWidthChildren[1].trim().length === 0))) {
      minWidthChildren = [...minWidthChildren]
      minWidthChildren[1] = '\xa0'
    }
    childNode = editing ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingInlineEnd: 24, cursor: "pointer" }}
        onClick={toggleEdit}
      >
        foo
      </div>
    );
  } else {
    childNode = value ? 'Ja' : 'Nein'
  }

  return <>{ childNode }</>
}

export default BooleanRenderer;